import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoPedidoSetorGepMultiselectComponent } from './novo-pedido-setor-gep-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoPedidoSetorGepMultiselectComponent],
  exports: [NovoPedidoSetorGepMultiselectComponent]
})
export class NovoPedidoSetorGepMultiselectModule {}
